import React from "react";
import "./CurrentDashboardCard.css";
import { 
  MapIcon, 
} from "../../../../Components/IconComponents";

// ── Icons for Categories ──────────────────────────────────────────────────
const CATEGORY_ICONS = {
  "geographic": { 
    icon: (color) => <MapIcon style={{ width: "18px", height: "18px", color }} />,
    bg: "#EBF4FF", color: "#2A6591" 
  },
  "social": { 
    icon: (color) => (
      <svg viewBox="0 0 24 24" fill="none" width="18" height="18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    bg: "#FFF4EA", color: "#D4772A" 
  },
};

const METRIC_PALETTE = [
  { bg: "#EBF4FF", color: "#2A6591" },
  { bg: "#F3F0FF", color: "#7C3AED" },
  { bg: "#F0F9FF", color: "#0284C7" },
  { bg: "#F0FFF4", color: "#22C55E" },
];

export default function CurrentDashboardCard({
  data,
  config,
  clickedKey,
  setClickedKey,
  triggeredFunction,
}) {
  const cardData = data || {};

  const formatValue = (val) => {
    if (val == null) return "0";
    return Number(val).toLocaleString("en-IN");
  };

  const handleCardClick = (conf) => {
    setClickedKey(conf.key);
    triggeredFunction(
      conf.label,
      conf.apiKey,
      conf.key,
      conf.apiKey2,
      conf.keyName
    );
  };

  const catStyle = CATEGORY_ICONS[config.iconType] || CATEGORY_ICONS["geographic"];

  return (
    <div className="flood-curr-group">
      {/* Category Title */}
      <div className="flood-curr-group-title">
        <span className="flood-curr-group-icon" style={{ background: catStyle.bg, color: catStyle.color }}>
          {catStyle.icon(catStyle.color)}
        </span>
        <span>{config.title}</span>
      </div>

      {/* Cards Row */}
      <div className="flood-curr-group-cards">
        {config?.data.map((conf, index) => {
          const isActive = clickedKey === conf.key;
          const p = METRIC_PALETTE[index % METRIC_PALETTE.length];

          return (
            <div
              key={index}
              className={`flood-curr-pill ${isActive ? "flood-curr-pill--active" : ""}`}
              onClick={() => handleCardClick(conf)}
            >
              <div className="flood-curr-pill-icon" style={{ background: p.bg, color: p.color }}>
                {/* Simplified icon if specific one not provided */}
                <svg viewBox="0 0 24 24" fill="none" width="16" height="16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
                </svg>
              </div>
              <div className="flood-curr-pill-info">
                <span className="flood-curr-pill-label">{conf.label}</span>
                <span className="flood-curr-pill-value">{formatValue(cardData[conf.key])}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
